import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import moment from "moment-timezone";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { useDispatch } from "react-redux";

import ToolTipContent from "../../Common/ToolTipContent/ToolTipContent";
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";

import { openHeaderModal } from "../../../actions/siteadmin/modalActions";
import { api, categoryUploadDir } from "../../../config";
import history from "../../../history";
import messages from "../../../locale/messages";

import { getStatusText } from "../../../helpers/statusText";


import locationIcon from "../../../../public/dashboard/locationIcon.svg";
import categoryNameIcon from "../../../../public/dashboard/categoryNameIcon.svg";
import defaultDateIcon from '../../../../public/Icons/defaultSmallDateIcon.svg';
import { BookingItemEditIcon, CancelIcon, EyeIcon } from "../../Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../../commonStyle.css'
import s from './BookingItem.css';


const BookingItem = (props) => {
    const {
        id,
        categoryImage,
        amount,
        currency,
        categoryName,
        endLocation,
        paymentStatus,
        status,
        dateAndTime,
        bookingType,
        scheduleId,
        scheduleFrom,
        userId,
        type,
        intl: { formatMessage, locale }
    } = props

    const handleClick = () => {
        history.push({
            pathname: `/booking/${id}`,
            state: { from: history.location.pathname }
        });
    };
    let formData = {
        id,
        scheduleFrom: moment(parseInt(scheduleFrom)),
        scheduleId,
        currency,
        userId,
        isUserBooking: true
    }

    const dispatch = useDispatch()
    const { text: bookingStatusText, color: bookingStatusColor } = getStatusText({ status, paymentStatus })
    let createdAt = moment(parseInt(dateAndTime)).format('dddd, DD-MM-YYYY / h:mm A');
    let scheduledDate = moment(parseInt(scheduleFrom)).locale(locale).format(`ddd, MMM D, [${formatMessage(messages.at)}] h:mm A`);
    return (
        <div className={s.bookingCardItemContainer}>
            <div onClick={() => handleClick()} className={cx(s.bookingCardItemImgContainer, bt.cursorPointer)}>
                <img src={`${api.apiEndpoint}${categoryUploadDir}medium_${categoryImage}`} />
            </div>
            <div className={s.bookingCardItemInfoContainer}>
                <div className={s.bookingCardItemInfoLsContainer}>
                    <div className={cx(s.bookingCardItemInfoTooltipContainer, 'svgImg', bt.cursorPointer)}>
                        <ToolTipContent label={<FormattedMessage {...messages.toolTipForBookings} />} />
                        <div onClick={() => handleClick()}>
                            <CurrencyConverter amount={amount} from={currency} />
                        </div>
                    </div>
                    <div onClick={() => handleClick()} className={cx(s.bookingCardItemInfoType, 'svgImg', bt.cursorPointer)}>
                        <img src={categoryNameIcon} />
                        <span className={s.bookingCardItemInfoTypeLink}>{categoryName}</span>
                    </div>
                    <div>
                        {
                            (bookingType == 1 || bookingType == 2)  && <div className={cx(s.bookingCardItemInfoType, 'svgImg', bt.cursorPointer)} onClick={() => handleClick()}>
                                <img src={locationIcon} alt="locationIcon" />
                                <span className={s.bookingCardItemInfoLocationText}>{endLocation}</span>
                            </div>
                        }
                        {
                            bookingType == 1 && type == 'previous' && <div className={cx(s.bookingCardItemInfoType, 'svgImg')}>
                                <img src={defaultDateIcon} alt="defaultDateIcon" />
                                <span className={s.bookingCardItemInfoLocationText}>{createdAt}</span>
                            </div>
                        }
                        {
                            bookingType == 2 &&
                            <>
                                <div onClick={handleClick} className={cx(s.bookingCardItemInfoType, 'svgImg', bt.cursorPointer)}>
                                    <img src={defaultDateIcon} alt="scheduleIcon" />
                                    <div className={s.bookingCardItemInfoLocationText}>
                                        <span>
                                            <FormattedMessage {...messages.scheduledOn} />
                                        </span>
                                        <span>
                                            &nbsp;{scheduledDate}
                                        </span>

                                    </div>
                                </div>
                                {status === 'scheduled' && <div className={bt.commonCardLinkContainer}>
                                    <a href={'#'} onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(openHeaderModal('scheduleBookingForm', formData))
                                    }} className={bt.commonLinkWithIcon}>
                                        <BookingItemEditIcon className={s.commonCardLinkIcon14} />
                                        <FormattedMessage {...messages.editDateAndTime} />
                                    </a>
                                    <a href={'#'} onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(openHeaderModal('cancelScheduleBooking', formData));
                                    }} className={bt.commonLinkWithIcon}>
                                        <CancelIcon className={s.commonCardLinkIcon14} />
                                        <FormattedMessage {...messages.cancelJob} />
                                    </a>
                                </div>}
                            </>
                        }
                    </div>
                    <div>
                        <a href={`/booking/${id}`}
                            onClick={(e) => {
                                e.preventDefault();
                                history.push({ pathname: `/booking/${id}`, state: { from: history.location.pathname } });
                            }}
                            className={bt.commonLinkWithIcon}
                        >
                            <EyeIcon />
                            <FormattedMessage {...messages.viewDetails} />
                        </a>
                    </div>
                </div>
                <div className={s.bookingCardItemInfoRsContainer}>
                    <div className={s.bookingCardItemInfoIdBox}>
                        <span className={bt.displayInlineBlock}><FormattedMessage {...messages.idText} /></span>
                        <span className={bt.displayInlineBlock}>&nbsp;#{id}</span>
                    </div>
                    <p className={s.bookingCardItemInfoLink}>
                        {bookingStatusText === 'proceedToPay' ? (
                            <a href={`/tracking/${id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push({ pathname: `/tracking/${id}`, state: { from: history.location.pathname } });
                                }}
                                className={bt.commonLinkWithIcon}
                            >
                                <FormattedMessage {...messages.proceedToPay} />
                            </a>
                        ) : bookingStatusText ? (
                            <span className={s.bookingStatusText} style={{ color: bookingStatusColor }}><FormattedMessage {...messages[bookingStatusText]} /></span>
                        ) : (
                            <a href={`/tracking/${id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push({ pathname: `/tracking/${id}`, state: { from: history.location.pathname } });
                                }}
                                className={bt.commonLinkWithIcon}
                            >
                                <FormattedMessage {...messages.trackJob} />
                            </a>
                        )
                        }
                    </p>
                </div>
            </div >
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(BookingItem));
